import { forwardRef, ReactNode } from 'react';

import clsx from 'clsx';

import styles from '../Carousel.module.css';

export type CarouselArrowsProps = {
	children: ReactNode;
	className?: string;
};

export const CarouselArrows = forwardRef<HTMLDivElement, CarouselArrowsProps>(({ children, className }, ref) => {
	return (
		<div
			ref={ref}
			className={clsx(styles.carouselArrows, className)}
		>
			{children}
		</div>
	);
});

CarouselArrows.displayName = 'CarouselArrows';
